import axios from "axios";
import {
  UPDATE_DATA,
  GET_ALL_SYLLABUS,
  GET_ALL_SECTION,
  USER_REGISTRATION_DATA,
  GET_ALL_ADVERTISEMENT,
  GET_ADMISSION_CONFIGURATION
} from "./types";
const keys = require("../config/keys");

export const registrationInquiryInsertUpdate = data => async dispatch => {
  let isRegSuccess = false;
  await axios({
    method: "post",
    url:
      keys.ServicePath + "/api/AdmissionInqury/RegistrationInquiryInsertUpdate",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          isRegSuccess = res.data.isRegSuccess;
          const msg = {
            event: "success",
            action: "add",
            page: "Registration",
            data: res.data.data,
            success: true,
            ...res.data
          };
          if (!res.data.userAvl) {
            dispatch({ type: UPDATE_DATA, payload: msg });
          }
          dispatch({ type: USER_REGISTRATION_DATA, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
  return isRegSuccess;
};

export const getAllSyllabus = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionInqury/GetAllSyllabus"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: GET_ALL_SYLLABUS, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllSection = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionInqury/GetAllSection"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: GET_ALL_SECTION, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllAdvertisement = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionInqury/GetAllAdvertisement"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: GET_ALL_ADVERTISEMENT, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const checkUserVerifyOtpDetails = data => async dispatch => {
  let isOtpVerify = false;
  let isError = false;
  let errorMsg = "";
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionInqury/CheckVerifyOtpData",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          let msg;
          if (res.data.isOtpVerify) {
            isOtpVerify = true;
            msg = {
              event: "success",
              data: res.data.data,
              success: true,
              ...res.data
            };
          } else {
            isOtpVerify = false;
            isError = true;
            errorMsg = "OTP Is Invalid";
            msg = {
              event: "error",
              data: res.data.data,
              success: true,
              ...res.data
            };
          }
          dispatch({ type: UPDATE_DATA, payload: msg });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
  return { isOtpVerify, isError, errorMsg };
};

export const ResendOtpDetails = data => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionInqury/ResendOtpData",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          var msg = {
            event: "success",
            data: res.data.data,
            success: true,
            ...res.data
          };
          dispatch({ type: UPDATE_DATA, payload: msg });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAdmissionConfiguration = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionInqury/GetAdmissionConfiguration"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ADMISSION_CONFIGURATION,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/admissionInquryRegistration.js